<template>
  <div>
    <Header></Header>
    <h1>This page is coming soon...</h1>
  </div>
</template>

<script>
const Header = () => import('../components/Header.vue')

export default {
  name: 'comingSoon', //this is the name of the component
  title: 'comingSoon',
  components: {
    'Header': Header,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  margin-top: 200px;
  margin-bottom: 300px;
}
</style>
